import { render, staticRenderFns } from "./BrandVerdico.vue?vue&type=template&id=17508eaa&scoped=true&"
import script from "./BrandVerdico.vue?vue&type=script&lang=js&"
export * from "./BrandVerdico.vue?vue&type=script&lang=js&"
import style0 from "./BrandVerdico.vue?vue&type=style&index=0&id=17508eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17508eaa",
  null
  
)

export default component.exports